export default "__VITE_ASSET__lTA6qG3j__"